module.exports = __webpack_public_path__ + "static/media/haute8B.3b90efb6.jpg";